import { render, staticRenderFns } from "./AlterPassword.vue?vue&type=template&id=6d353914&scoped=true&"
import script from "./AlterPassword.vue?vue&type=script&lang=js&"
export * from "./AlterPassword.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/util.css?vue&type=style&index=0&id=6d353914&scoped=true&lang=css&"
import style1 from "./AlterPassword.vue?vue&type=style&index=1&id=6d353914&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d353914",
  null
  
)

export default component.exports